/**
 * Thin wrapper that mounts ApprovalWorkspace inside the evaluation shell.
 * All workspace logic — chain builder, readiness, in-flight timeline — lives
 * in `components/approvals/ApprovalWorkspace.tsx` (D4 / MYD-203). The legacy
 * Kanban-by-decision view is gone; sequential chain semantics replace it.
 */

import { useOutletContext } from 'react-router-dom'
import type { EvaluationOutletContext } from '../Evaluations_ShowCN'
import ApprovalWorkspace from './approvals/ApprovalWorkspace'

const EvaluationApprovals = () => {
	const { evalId, evaluationStatus } = useOutletContext<EvaluationOutletContext>()
	return <ApprovalWorkspace evalId={evalId} evaluationStatus={evaluationStatus} />
}

export default EvaluationApprovals
